
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sneakers/running",
      function () {
        return require("private-next-pages/sneakers/running.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sneakers/running"])
      });
    }
  